/**
 * Computes the user's current age in whole years from their date of birth.
 *
 * @param dateOfBirth - ISO date string or Date object (can be null/undefined)
 * @returns Age in whole years, or null if DOB is unknown
 */
export function getAge(
  dateOfBirth: string | Date | null | undefined,
): number | null {
  if (!dateOfBirth) return null;

  const dob =
    typeof dateOfBirth === "string" ? new Date(dateOfBirth) : dateOfBirth;
  if (isNaN(dob.getTime())) return null;

  const now = new Date();
  let age = now.getFullYear() - dob.getFullYear();
  const monthDiff = now.getMonth() - dob.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < dob.getDate())) {
    age -= 1;
  }

  return age;
}
